enum OrganizationSetting {
  ACTIVE_CHECK_IN = "activeCheckIn",
  ACTIVE_CHECK_IN_ACCESS = "activeCheckInAccess",
  ACTIVITY_COMPLETION_STATUS = "activityCompletionStatus",
  ACTIVITY_VISIBILITY = "activityVisibility",
  ALLOW_OWNERSHIP_TO_ALL_USERS = "allowOwnershipToAllUsers",
  ALLOW_PHI_ACCESS_TO_MMC = "allowPHIAccessToMMC",
  CALENDAR_SYNC_PREFERENCES = "calendarSyncPreferences",
  CHECK_IN_RADIUS = "reliabilityThreshold",
  CHECK_IN_VERIFIED_VISIBILITY = "checkInVerifiedVisibility",
  CLOSED_DATE_UPDATE_PREFERENCE = "closedDateUpdatePreference",
  COACHING_AND_INSIGHTS = "coachingAndInsights",
  COACHING_AND_INSIGHTS_ACCESS = "coachingAndInsightsAccess",
  CROSS_OBJECT_ACTIVITY_VISIBILITY = "crossObjActivityVisibility",
  CURRENCY = "currency",
  DEFAULT_CHECK_IN_ACTIVITY_TYPE = "defaultCheckInActivityType",
  DISTANCE_UNIT = "distanceUnit",
  DUPLICATE_CHECK = "duplicateCheck",
  DUPLICATE_CHECK_CRITERIA = "duplicateCheckCriteria",
  DUPLICATE_CHECK_LOGIC = "duplicateCalculationLogic",
  DUPLICATE_MERGE_ACCESS = "dupeMergeAccess",
  EMAIL_BOILERPLATE = "emailBoilerplate",
  ENABLE_SCORECARD_FOR_NEW_USERS = "enableReportCardForNewUsers",
  EXPORT_UID = "apostropheUID",
  FEATURE_REQUEST_NOTIFICATIONS = "featureRequestNotifications",
  FIELD_AGENT_BRIEF_INSTRUCTION = "fieldAgentBriefInstruction",
  FIELD_AGENT_RECAP_INSTRUCTION = "fieldAgentRecapInstruction",
  IMPORT_ALLOWED = "importAllowed",
  LEAD_GEN_CHECK = "leadGenCheck",
  LEAD_GEN_ENTITY = "leadGenEntity",
  LEADERBOARD_VISIBILITY = "leaderboardVisibility",
  LOGO = "logo",
  NEAR_BY_SUGGESTION_ACTIVITY_TYPE = "nearbySuggestionActivityType",
  NEW_ROUTE_SUGGESTION_ACTIVITY_TYPE = "newRouteSuggestionActivityType",
  MILEAGE_TRACKING_RATE = "tripsRate",
  MILEAGE_TRACKING_VISIBILITY = "tripsReimbursementVisibleTo",
  RESOURCE_AND_FOLDER_SHARING = "resourceAndFolderSharing",
  SSO_LOGIN_APPROVAL_REQUIRED = "ssoLoginApprovalRequired",
  STACK_RANK_CUSTOM_METRICS = "stackRankCustomMetrics",
  TIMEZONE = "timezone",
  USER_LOCATION_VISIBILITY = "userLocationVisibility",
}

export default OrganizationSetting;
